/*
 * Example article
 *
  {
    id: 1,
    title: 'The Test Article',
    slug: 'the_test_article',
    // Generated from https://www.unixtimestamp.com/
    published_at: 1516745276, // 01/23/2018 @ 10:07pm (UTC)
    featured: true,
    image: 'test-article.jpg',
    author_name: 'Cale Crawford',
    author_title: 'Developer',
    author_image: 'cale.jpg',
    preview:
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in
      eros elementum tristique. Duiscursus, mi quis viverra ornare, eros dolor interdum nulla,
      ut commodo diam libero vitae erat. Aenean faucibus nibhet justo cursus id rutrum lorem
      imperdiet. Nunc ut sem vitae risus tristique posuere.`,
    content: 'the-test-article.md',
  },
 *
 *
*/
const projectList = [
  {
    id: 1,
    title: 'Delivering real-time solutions for dining and auxillary services.',
    subtitle: 'Serving hundreds of thousands of users every month.',
    slug: 'real_time_dining_solutions',
    category: 'webdesign',
    featured: true,
    image: 'project1_main.jpg',
    description_images: [
      'project1_0.jpg',
      'project1_1.jpg',
      'project1_2.jpg',
      'project1_3.jpg',
    ],
    description: 'the-test-project.md',
  },
  {
    id: 2,
    title: 'Serving up menu solutions for K-12.',
    subtitle: 'A new app for macbook',
    slug: 'k_12_dining',
    category: 'webdesign',
    featured: false,
    image: 'project2_main.jpg',
    description_images: [
      'project1_0.jpg',
      'project1_1.jpg',
      'project1_2.jpg',
      'project1_3.jpg',
    ],
    description: 'the-test-project.md',
  },
  {
    id: 3,
    title: 'See our mobile platform in action.',
    subtitle: 'A new app for macbook',
    slug: 'mobile_platform',
    category: 'webdesign',
    featured: false,
    image: 'project3_main.jpg',
    description_images: [
      'project1_0.jpg',
      'project1_1.jpg',
      'project1_2.jpg',
      'project1_3.jpg',
    ],
    description: 'the-test-project.md',
  },
  {
    id: 4,
    title: 'Meaningful insights into trends and behavior.',
    subtitle: 'A new app for macbook',
    slug: 'behavior_trends',
    category: 'webdesign',
    featured: false,
    image: 'project4_main.jpg',
    description_images: [
      'project1_0.jpg',
      'project1_1.jpg',
      'project1_2.jpg',
      'project1_3.jpg',
    ],
    description: 'the-test-project.md',
  },
  {
    id: 5,
    title: 'Your customers are mobile. Are you?',
    subtitle: 'A new app for macbook',
    slug: 'mobile_customers',
    category: 'webdesign',
    featured: false,
    image: 'project5_main.jpg',
    description_images: [
      'project1_0.jpg',
      'project1_1.jpg',
      'project1_2.jpg',
      'project1_3.jpg',
    ],
    description: 'the-test-project.md',
  },
]

export default {
  getProjects(cb) {
    setTimeout(() => cb(projectList), 0)
  },
}
